import { TechInfo } from "../../dental-tech-info"

export const AdminTechInfo = () => {
    return <div className="admin-section pt-4 pb-4">

        <TechInfo userExist={true} editable={false} />
    </div>
}